import React, {useEffect, useRef, useState} from 'react';
import * as Yup from 'yup';
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import AsyncCreatableSelect from "react-select/async-creatable";
import {axiosInstance} from "../../../utils/axiosInstance";
import {InputDatePicker} from "jalaali-react-date-picker";
import "jalaali-react-date-picker/lib/styles/index.css";
import DynamicForm from "../../../components/form/dynamicForm";
import {newsTypeOptions} from "../../../services/types/news";
import {DtPicker} from 'react-calendar-datetime-picker'
import 'react-calendar-datetime-picker/dist/style.css'
import {parseIDayToDateStr, toEnDigit} from "../../../utils/time";
import moment from "moment-jalaali";
import {slugify} from "../../../utils/slug";

// Register FilePond plugins
registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

const CreateNews = () => {

        useEffect(() => {
            const loadTagsOptions = async () => {
                const tagsSearchResponse = await axiosInstance.get('tags');
                const tags = tagsSearchResponse.data.results;

                const mappedTagOptions = tags.map((tag) => ({
                    value: tag.id, label: tag.name, createdAt: tag.created_at
                }));

                // Update the tagsOptions with newly fetched options
                setTagsOptions((prevOptions) => {
                    return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
                });
            }
            const loadCategories = async () => {
                const tagsSearchResponse = await axiosInstance.get('categories', {
                    params: {
                        page_size: 999
                    }
                });
                const tags = tagsSearchResponse.data.results;

                const mappedTagOptions = tags.map((tag) => ({
                    value: tag.id, label: tag.name, createdAt: tag.created_at
                }));

                // Update the tagsOptions with newly fetched options
                setCategories((prevOptions) => {
                    return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
                });
            }
            try {
                setloading(true)
                loadTagsOptions()
                loadCategories()
            } catch (e) {

            } finally {
                setloading(false)
            }
        }, [])
        // tags
        const [tagsOptions, setTagsOptions] = useState([]);
        const [loading, setloading] = useState(false)

        const [categories, setCategories] = useState([])

        // dynamic form
        const meta = {
            gridColumns: {
                small: 1, medium: 3, large: 4
            },
        };


        const fields = [{
            title: 'عنوان', fieldName: 'title', type: 'string', validation: (value) => Yup.string().max(255).required(),
        },{
            title: 'سرتیتر', fieldName: 'headline', type: 'string', validation: (value) => Yup.string().max(255),
        }, {
            title: 'اسلاگ', fieldName: 'slug', type: 'string', validation: (value) => {
                const re = RegExp(`^[a-z0-9]+(?:(?:-|_)+[a-z0-9]+)*$`)
                if (!re.test(value)) {
                    return 'فقط حروف انگلیسی و اعداد. با - جدا کنید'
                } else {
                    return null
                }
            }, onChange: (value) => {
                value.target.value = slugify(value.target.value)
                return value
            }
        },
            {
                title: 'طبقه بندی',
                fieldName: 'category',
                type: 'selectbox',
                options: categories,
                validation: (value) => Yup.object().required(),
            }, {
                title: 'نوع',
                fieldName: 'type',
                type: 'selectbox',
                options: newsTypeOptions.filter((option) => option.value != null),
                validation: (value) => Yup.object().required(),
            },
            {
                title: 'اولویت',
                fieldName: 'priority',
                type: 'number',
                validation: (value) => Yup.string(),
            },
            {
                title: 'تصویر خبر',
                fieldName: 'thumbnail',
                type: 'file',
                accept: 'image/*',
                ref: React.createRef(), // To trigger file input click
                colSpan: 2, // Adjust layout as needed
            },
            {
                title: 'تگ ها', fieldName: 'tags', type: 'custom', validation: () => null, // No validation for this field
                template: (formik, fieldName) => (<AsyncCreatableSelect
                    isClearable
                    // isDisabled={tagsLoading}
                    isMulti
                    isLoading={loading}
                    defaultOptions={tagsOptions} // Ensure this is set properly
                    onChange={(option) => formik.setFieldValue(fieldName, option)}
                    formatCreateLabel={(inputText) => `ساخت "${inputText}"`}
                    loadOptions={async (value) => {
                        const tagsSearchResponse = await axiosInstance.get('tags', {
                            params: {name: value}
                        });
                        const tags = tagsSearchResponse.data.results;

                        const mappedTagOptions = tags.map((tag) => ({
                            value: tag.id, label: tag.name,
                        }));

                        // Update the tagsOptions with newly fetched options
                        setTagsOptions((prevOptions) => {
                            return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
                        });

                        return mappedTagOptions;
                    }}
                    onCreateOption={async (inputValue) => {
                        const createTagResponse = await axiosInstance.post('tags', {name: inputValue});
                        const newTag = {
                            value: createTagResponse.data.data.id, label: inputValue, createdAt: new Date().toISOString(),
                        };

                        // Update tagsOptions to include the new tag
                        setTagsOptions((prev) => {
                            let newOptions = [...prev, newTag];
                            newOptions.sort((a, b) => {
                                return a.createdAt > b.createdAt ? 1 : -1;
                            })
                            return Array.from(new Map(newOptions.map(item => [item.value, item])).values());
                        });

                        await formik.setFieldValue(fieldName, newTag); // Set the new tag in Formik state
                        return newTag; // Return the new tag to be added in the select options
                    }}
                    isRtl
                    placeholder="انتخاب کنید"
                />),
            }, {
                title: 'زمان انتشار',
                fieldName: 'published_at',
                type: 'datepicker',
                validation: (value) => !value ? 'زمان انتشار الزامی است' : null,
            }, {
                title: 'پیشنهاد سردبیر',
                fieldName: 'editor_suggestion',
                type: 'checkbox',
                validation: () => Yup.string().required(),
            }, {
                title: 'فعال',
                fieldName: 'is_active',
                type: 'checkbox',
                validation: () => Yup.string().required(),
            },
            {
                title: 'توضیحات',
                fieldName: 'description',
                type: 'custom',
                validation: () => Yup.string().required(),
                template: (formik, fieldName) => (<div className='w-full'>
                <textarea className='w-full p-2 border rounded-lg'
                          onChange={(value) => formik.setFieldValue(fieldName, value.target.value)}
                          value={formik.values[fieldName]}/>
                </div>),
                colSpan: 3,
            }, {
                title: 'بدنه', // "Body"
                fieldName: 'body',
                type: 'text-editor',
                validation: () => Yup.string().required('This field is required'),
                wrapper: (content) => (
                    <div className="pb-8">
                        {content}
                    </div>
                ),
                ref: useRef(),
                colSpan: 3,
            },
        ];

        const convertToGregorian = (jalaaliDateString) => {
            jalaaliDateString = toEnDigit(jalaaliDateString); // Convert Persian/Arabic digits to English

            // Parse the Jalaali date string with an explicit timezone offset
            const gregorianDate = moment(jalaaliDateString, 'jYYYY-jMM-jDD HH:mm:ss')
                .utcOffset('+03:30', true); // Adjust for the Iran Standard Time offset

            return gregorianDate.format('YYYY-MM-DDTHH:mm:ssZ'); // Format with the correct timezone
        };

        return (!loading && <DynamicForm
            fields={fields}
            meta={meta}
            showPreviewButton={true}
            previewOnClick = {async (values) => {
                values.type = values.type.value
                values.category = values.category.value
                values.tags = values.tags?.map(t => t.value).join(',') || ''
                values.author = 1
                values.published_at = convertToGregorian(values.published_at)
                values.thumbnail = values.thumbnail['file']
                values.is_preview = true
                // values.headline = values.headlline
                console.log('Form values:', values);
                const createNewsResponse = await axiosInstance.post('news', values, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                if (createNewsResponse.status != 201) {
                    throw new Error("خطا در ثبت خبر")
                }
                const newNewsId = createNewsResponse.data.data.id
                window.open(`https://naftkhabar.com/short/${newNewsId}?preview=true`, '_blank')
                // window.open(`http://localhost:6574/short/${newNewsId}?preview=true`, '_blank')
            }}
            onSubmit={async (values) => {
                values.type = values.type.value
                values.category = values.category.value
                values.tags = values.tags?.map(t => t.value).join(',') || ''
                values.author = 1
                values.published_at = convertToGregorian(values.published_at)
                values.thumbnail = values.thumbnail['file']
                // values.headline = values.headlline
                console.log('Form values:', values);
                const createNewsResponse = await axiosInstance.post('news', values, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                if (createNewsResponse.status != 201) {
                    throw new Error("خطا در ثبت خبر")
                }
                const newNewsId = createNewsResponse.data.data.id
                window.location.href = `/admin/news`
            }}
        />);
    }
;

export default CreateNews;